import { setLabels } from "../helpers/enum-helpers";

export enum OutboundLoadExceptionType {
  Crossdock = 1,
}

setLabels(OutboundLoadExceptionType);
